import BaseService from 'services/BaseService';

export default class ContainerService extends BaseService {
	_type = 'container';
	_typeKey = 'container_group_type';
}
